// Optional waiver attachments for Outbox drafts — the single source of truth
// shared by the Outbox UI (which shows the toggle + injects the note into the
// email body) and api/send-email.js (which fetches and attaches the PDF at send
// time). Pure module: no browser/node deps, so the serverless email function can
// import it too. Same shape as careGuide.js.
//
// The waiver PDFs live as static files in public/waivers/. Drop a correctly
// named file in there and it starts attaching — no code change needed. A missing
// file is a graceful no-op (the email still sends, just without the PDF).

export const BIOHAZARD_WAIVER = {
  file: 'biohazard-waiver.pdf',
  filename: 'Biohazard Waiver.pdf', // shown to the customer
  label: 'Biohazard Waiver',        // shown in the Outbox chip
};

// The paragraph added to the pre-email body when the waiver is attached. Kept
// here (not inlined in the UI) so the toggle, the draft builder and Regenerate
// all produce byte-identical text — that exact match is what makes toggling the
// waiver back OFF able to cleanly remove the note again.
export const BIOHAZARD_NOTE =
  'Attached is our biohazard waiver. Please fill it out and bring it with you to the shop at the time of your appointment, or email it back to us as soon as possible.';

// The pre-email builder's closing line — the note is inserted just above it.
const SIGNOFF = '— 3C Detailing';

export function hasBiohazardNote(body) {
  return String(body || '').includes(BIOHAZARD_NOTE);
}

// Insert the note immediately above the sign-off (or append it if the operator
// rewrote the body and there's no sign-off left). Idempotent.
export function withBiohazardNote(body) {
  const t = String(body || '');
  if (hasBiohazardNote(t)) return t;
  const i = t.lastIndexOf(SIGNOFF);
  if (i === -1) return t.trim() ? t.trimEnd() + '\n\n' + BIOHAZARD_NOTE : BIOHAZARD_NOTE;
  return t.slice(0, i).trimEnd() + '\n\n' + BIOHAZARD_NOTE + '\n\n' + t.slice(i);
}

// Remove the note again, collapsing the blank line it left behind so the body
// round-trips back to exactly what it was before the note was added.
export function withoutBiohazardNote(body) {
  const t = String(body || '');
  if (!hasBiohazardNote(t)) return t;
  return t.split(BIOHAZARD_NOTE).join('').replace(/\n{3,}/g, '\n\n').trimEnd();
}
